<template>
  <div>
    <div v-for="(msg, index) in sortMsgById" :key="index + msg.id" :data="msg">
      <br />
      <br />

      <div class="row">
        <div v-if="msg.inOut === 5" class="mx-auto">
          <div class="card wa-card" style="padding: 10px; border-radius: 10px">
            <span
              style="color: #000; white-space: pre-line"
              v-html="msg.texto"
            ></span>
          </div>
        </div>
        <div
          v-if="msg.inOut !== 5"
          :class="msg.inOut === 1 ? 'col-5' : 'offset-6 col-5'"
        >
          <div
            :style="
              msg.inOut === 1
                ? 'width: fit-content; min-width: 60%;'
                : 'width: fit-content; min-width: 60%; float:right;'
            "
          >
            <div
              :class="
                msg.inOut === 1 && msg.inOut !== 5
                  ? 'card wa-card-chat wa-card-default'
                  : 'card wa-card-chat wa-card-green'
              "
            >
              <v-alert
                v-if="msg.quotedMsg"
                class="mx-auto"
                text
                elevation="2"
                colored-border
                border="left"
                style="width: 100%"
                color="black"
              >
                <div
                  style="
                    width: 20vh;
                    overflow-x: hidden;
                    overflow-wrap: break-word;
                    word-wrap: break-word;
                    word-break: break-all;
                    text-overflow: ellipsis;
                  "
                >
                  {{ msg.quotedMsg.body || msg.quotedMsg.caption }}
                </div>
                <div v-if="msg.quotedMsg.type !== 'chat'">
                  <img
                    v-if="
                      msg.quotedMsg.mimeType &&
                      (msg.quotedMsg.mimeType.indexOf('image') !== -1 ||
                        msg.quotedMsg.mimeType.indexOf('sticker') !== -1)
                    "
                    style="height: 25vh; max-width: 400px; cursor: pointer"
                    :src="ip + msg.quotedMsg.caminho"
                    @click="
                      $emit(`openImage`, {
                        file: msg.quotedMsg,
                        local: false,
                      })
                    "
                  />

                  <video
                    height="300"
                    controls
                    v-if="
                      msg.quotedMsg.mimeType &&
                      msg.quotedMsg.mimeType !== null &&
                      msg.quotedMsg.mimeType.indexOf('video') !== -1
                    "
                  >
                    <source
                      :src="ip + msg.quotedMsg.caminho"
                      :type="msg.quotedMsg.mimeType"
                    />
                  </video>

                  <audio
                    v-if="
                      msg.quotedMsg.mimeType &&
                      msg.quotedMsg.mimeType.indexOf('audio') !== -1
                    "
                    preload="none"
                    controls
                  >
                    <source
                      :src="ip + msg.quotedMsg.caminho"
                      :type="msg.quotedMsg.mimeType"
                    />
                  </audio>
                  <v-btn
                    icon
                    v-if="
                      msg.quotedMsg.mimeType &&
                      msg.quotedMsg.mimeType.indexOf('image') === -1 &&
                      msg.quotedMsg.mimeType.indexOf('audio') === -1 &&
                      msg.quotedMsg.mimeType.indexOf('video') === -1
                    "
                  >
                    <a :href="ip + msg.quotedMsg.caminho">
                      <v-icon>mdi-file-download-outline</v-icon>
                    </a>
                  </v-btn>
                </div>
              </v-alert>
              <v-hover
                v-if="atendimento.queueTypeID === 3"
                v-slot:default="{ hover }"
              >
                <div style="display: flex">
                  <span
                    style="
                      font-style: italic;
                      font-size: 0.8em;
                      font-weight: bold;
                      flex: 1;
                    "
                    v-if="msg.inOut !== 1"
                    v-html="msg.agente"
                  ></span>
                  <span
                    style="
                      font-style: italic;
                      font-size: 0.8em;
                      font-weight: bold;
                      flex: 1;
                    "
                    v-if="msg.inOut == 1"
                    v-html="atendimento.fromName || 'Cliente'"
                  ></span>
                  <span v-show="hover && msg.status !== `deleted`">
                    <v-menu open-on-click top offset-y>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">mdi-menu-down</v-icon>
                      </template>

                      <v-list>
                        <v-list-item
                          @click="$emit(`replyMsg`, msg)"
                          v-if="msg.inOut === 1"
                        >
                          <v-list-item-title>{{
                            t(`responder`)
                          }}</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          v-if="
                            msg.status !== `pending` &&
                            msg.status !== `deleted` &&
                            msg.inOut === 2
                          "
                          @click="$emit(`deleteMsg`, msg)"
                        >
                          <v-list-item-title>{{
                            t(`apagarMensagem`)
                          }}</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </span>
                </div>
              </v-hover>
              <span
                style="color:#000; max-width: 400px; !important;white-space: pre-line;"
                class="mt-1"
                v-if="msg.status !== `deleted`"
                v-html="msg.texto"
              ></span>
              <span
                v-else
                style="color:#000; max-width: 400px; !important;"
                class="mt-1"
              >
                <v-icon>mdi-cancel</v-icon>
                {{ t("mensagemApagada") }}
              </span>
              <div
                v-for="(file, index) in msg.queueAnexos"
                :key="index + `anexos`"
                style="text-align: center"
              >
                <img
                  v-if="
                    (file.mimeType &&
                      file.mimeType !== null &&
                      file.mimeType.indexOf('image') !== -1 &&
                      msg.inOut === 2 &&
                      msg.id) ||
                    (file.mimeType &&
                      file.mimeType !== null &&
                      file.mimeType.indexOf('image') !== -1 &&
                      msg.inOut === 1)
                  "
                  style="height: 25vh; max-width: 400px; cursor: pointer"
                  :src="ip + file.caminho"
                  @click="$emit(`openImage`, { file: file, local: true })"
                />
                <img
                  v-if="
                    file.mimeType &&
                    file.mimeType !== null &&
                    file.mimeType.indexOf('image') !== -1 &&
                    msg.inOut === 2 &&
                    !msg.id
                  "
                  style="height: 25vh; max-width: 400px; cursor: pointer"
                  :src="file.caminho"
                  @click="$emit(`openImage`, { file: file, local: false })"
                />

                <video
                  height="300"
                  controls
                  v-if="
                    (file.mimeType &&
                      file.mimeType !== null &&
                      file.mimeType.indexOf('video') !== -1 &&
                      msg.inOut === 2 &&
                      msg.id) ||
                    (file.mimeType &&
                      file.mimeType !== null &&
                      file.mimeType.indexOf('video') !== -1 &&
                      msg.inOut === 1)
                  "
                >
                  <source :src="ip + file.caminho" :type="file.mimeType" />
                </video>
                <video
                  height="300"
                  controls
                  v-if="
                    file.mimeType &&
                    file.mimeType !== null &&
                    file.mimeType.indexOf('video') !== -1 &&
                    msg.inOut === 2 &&
                    !msg.id
                  "
                >
                  <source :src="file.caminho" :type="file.mimeType" />
                </video>

                <audio
                  v-if="
                    (file.mimeType &&
                      file.mimeType !== null &&
                      file.mimeType.indexOf('audio') !== -1 &&
                      msg.inOut === 2 &&
                      msg.id) ||
                    (file.mimeType &&
                      file.mimeType !== null &&
                      file.mimeType.indexOf('audio') !== -1 &&
                      msg.inOut === 1)
                  "
                  preload="none"
                  controls
                >
                  <source :src="ip + file.caminho" :type="file.mimeType" />
                </audio>
                <audio
                  v-if="
                    file.mimeType &&
                    file.mimeType !== null &&
                    file.mimeType.indexOf('audio') !== -1 &&
                    msg.inOut === 2 &&
                    !msg.id
                  "
                  preload="none"
                  controls
                >
                  <source :src="file.caminho" :type="file.mimeType" />
                </audio>
                <v-btn
                  icon
                  v-if="
                    file.mimeType &&
                    file.mimeType !== null &&
                    file.mimeType.indexOf('image') === -1 &&
                    file.mimeType.indexOf('audio') === -1 &&
                    file.mimeType.indexOf('video') === -1 &&
                    msg.id
                  "
                >
                  <a :href="ip + file.caminho" :download="file.caminho">
                    <v-icon>mdi-file-download-outline</v-icon>
                  </a>
                </v-btn>
                <v-btn
                  icon
                  v-if="
                    file.mimeType &&
                    file.mimeType !== null &&
                    file.mimeType.indexOf('image') === -1 &&
                    file.mimeType.indexOf('audio') === -1 &&
                    file.mimeType.indexOf('video') === -1 &&
                    !msg.id
                  "
                >
                  <a :href="file.caminho" download="file.caminho">
                    <v-icon>mdi-file-download-outline</v-icon>
                  </a>
                </v-btn>
              </div>
              <div style="text-align: right">
                <span
                  style="
                    font-style: italic;
                    font-size: 0.8em;
                    font-weight: bold;
                  "
                  >{{ formataHora(msg.dataHora) }}</span
                >
                <v-icon v-show="msg.inOut === 2 && msg.status === 'sended'"
                  >mdi-check</v-icon
                >

                <v-icon v-show="msg.inOut === 2 && msg.status === 'delivered'"
                  >mdi-check-all</v-icon
                >

                <v-icon
                  color="blue"
                  v-show="msg.inOut === 2 && msg.status === 'seen'"
                  >mdi-check-all</v-icon
                >
                <v-icon v-show="msg.inOut === 2 && msg.status === 'pending'"
                  >mdi-close</v-icon
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment-timezone";
import { mapState } from "vuex";
import { mapActions } from "vuex";

export default {
  props: {
    messages: { type: Array },
  },
  data() {
    return {
      ip: "http://" + JSON.parse(localStorage.getItem("config")).servidor,
    };
  },
  computed: {
    ...mapState(`xc`, {
      // messages: (state) => state.atendimento.messages,
      atendimento: (state) => state.atendimento,
      clientes: (state) => state.clientes,
    }),
    // messages() {
    //   return this.atendimento.messages;
    // },
    sortMsgById() {
      if (!this.atendimento.messages) return [];
      let msg = this.atendimento.messages;
      return msg.sort(function (a, b) {
        return a.id - b.id;
      });
    },
  },
  methods: {
    ...mapActions(`xc`, [
      "addAtendimento",
      "selectAtendimento",
      "sendMessage",
      "encerrarAtendimento",
      "getClassificacoes",
      "selectCliente",
      "setTransferenciaModal",
      "sendMessageFile",
      "getDefault",
      "setClassificacao",
      "getClientes",
      "setCliente",
      "addMessages",
      `deleteMsg`,
      `retryMsg`,
    ]),
    formataHora(dataHora) {
      moment.locale("pt-br");
      if (moment(dataHora).format("L") === moment(new Date()).format("L")) {
        return moment(dataHora).format("LT");
      } else {
        return moment(dataHora).format("lll");
      }
    },
    formataData(dataHora) {
      moment.locale("pt-br");
      return moment(dataHora).format("L");
    },
  },
};
</script>

<style>
</style>